class RbzPromotionPrice extends HTMLElement {
  connectedCallback() {
    const expiresAt = Date.parse(this.dataset.expiresAt || '');
    if (!Number.isFinite(expiresAt)) { this.removeAttribute('data-active'); return; }
    const remaining = expiresAt - Date.now();
    if (remaining <= 0) { this.removeAttribute('data-active'); return; }
    this.expiryTimer = window.setTimeout(() => { this.removeAttribute('data-active'); }, Math.min(remaining, 2147483647));
  }
  disconnectedCallback() { window.clearTimeout(this.expiryTimer); }
}
if (!customElements.get('rbz-promotion-price')) { customElements.define('rbz-promotion-price', RbzPromotionPrice); }
